import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import IELTStestPageListening from './listening_question/IELTStestPageListening'
import IELTStestPageReading from './reading_question/IELTStestPageReading'
import IELTStestPageWriting from './writing_question/IELTStestPageWriting'


const HomeTestFreePage = () => {
    const [page, setPage] = useState(1)
    const location = useLocation();
    
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            return (event.returnValue = ''); 
          }
          window.addEventListener('beforeunload', handleBeforeUnload);
          return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
          };
    },[])
  return (
    <>
      {
        location.state?.voucher?.id === 2 ? (
          <IELTStestPageReading nextPage={setPage} />
        ) : (
          page === 1 ? (<IELTStestPageListening nextPage={setPage} />) : 
          page === 2 ? (<IELTStestPageReading nextPage={setPage} />) : 
          page === 3 ? (<IELTStestPageWriting nextPage={setPage} />) : ''
        )
      }
    </>
  )
}

export default HomeTestFreePage